import LoadingSpinner from 'components/utilities/AppSpinner/LoadingSpinner';
import useAuthentication from 'hooks/useAuthentication';
import PropTypes from 'prop-types';
import React, { createContext } from 'react';

export const GlobalLoaderContext = createContext(false);

const GlobalLoaderProvider = ({ children }) => {
  // Extract globalLoader via useAuthentication (AuthenticationProvider must be an ancestor)
  const { globalLoader } = useAuthentication();
  return (
    <GlobalLoaderContext.Provider value={globalLoader}>
      {globalLoader && (
        <div
          className='bg-100 opacity-50'
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
          <LoadingSpinner grow='10' color='primary' className='fs-5' />
        </div>
      )}
      {children}
    </GlobalLoaderContext.Provider>
  );
};

GlobalLoaderProvider.propTypes = {
  children: PropTypes.node
};

export default GlobalLoaderProvider;
